import { Table } from "react-bootstrap";

import { HealthUnit } from "@/@types/sintegrada/HealthUnit";
import { RiskClassification } from "@/@types/sintegrada/RiskClassification";
import { ResumeGrouped } from "@/services/esus/attendanceService";

type Props = {
	aggregatedByHealthUnitAndRiskClassification: ResumeGrouped<
		HealthUnit,
		ResumeGrouped<RiskClassification, object>
	>[];
};

export function ClassificationByUbsTable({ aggregatedByHealthUnitAndRiskClassification }: Props) {
	// Extrair todas as classificações de risco únicas dos dados
	const riskClassifications = Array.from(
		new Map(
			aggregatedByHealthUnitAndRiskClassification
				.flatMap((healthUnitGroup) => healthUnitGroup.values || [])
				.map((riskClassificationGroup) => [
					riskClassificationGroup.key?.id,
					riskClassificationGroup.key,
				])
		).values()
	).filter(Boolean) as RiskClassification[];

	// Ordenar por ID para manter consistência
	riskClassifications.sort((a, b) => (a.id || 0) - (b.id || 0));

	return (
		<Table className="text-center" responsive striped bordered hover>
			<thead>
				<tr className="fw-bolder">
					<th className="ps-2 text-start">Unidade de saúde</th>
					{riskClassifications.map((riskClassification) => (
						<th
							key={`header-${riskClassification.id}`}
							style={{
								color: riskClassification.color,
								backgroundColor: `${riskClassification.color}15`,
							}}
						>
							{riskClassification.name}
						</th>
					))}
				</tr>
			</thead>
			<tbody>
				{aggregatedByHealthUnitAndRiskClassification.map((healthUnitGroup, index) => (
					<tr key={`health-unit-risk-classification-table-row-${index}`}>
						<td className="ps-2 text-start">{healthUnitGroup.key.name || "N/A"}</td>
						{riskClassifications.map((riskClassification) => (
							<td key={`cell-${healthUnitGroup.key.id}-${riskClassification.id}`}>
								{healthUnitGroup.values?.find(
									(riskClassificationGroup) =>
										riskClassificationGroup.key?.id === riskClassification.id
								)?.total || 0}
							</td>
						))}
					</tr>
				))}
			</tbody>
		</Table>
	);
}
